import React, {useState, useEffect, useCallback} from 'react';
import { useStateContext } from '../context/stateContext';
import { useParams, useNavigate } from 'react-router-dom';
import { data, urlRoot, bgEffects} from '../utils/data';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const Project = () => {
  const {lightTheme, setLinkHovred, setIsNotProject, setPrevLink, setNextLink} = useStateContext();
  const {id} = useParams();
  const idInt=parseInt(id);
  const navigate=useNavigate();
  const [currentProject, setCurrentProject] = useState(null);
  const [isPhone, setIsPhone] = useState(false);

  useEffect(()=>{
    // check the media if the user haves phone or else
    let phoneMedia=matchMedia('(max-width:767px)');
    if(phoneMedia.matches){
      setIsPhone(true);
    }

    // set the header links
    setIsNotProject(false);
    setPrevLink(`project/${idInt-1>0?idInt-1:idInt}`);
    setNextLink(`project/${idInt+1}`);

    // getting the project data
    let projectData=data.projects.find((prj)=>prj?.id==id);
    if(projectData){
      projectData.sliceIndex=Math.floor(projectData?.title?.length / 2);
      setCurrentProject(projectData)
    }else{
      navigate("/project/1");
    }

  },[idInt])
  
  // this fro particles
  const particlesInit = useCallback(async engine => {
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async container => {
      // await console.log(container);
  }, []);

  return (
    <section className={`project-section ${lightTheme ? "light" : "dark"}`}>
      <div
        className="container"
        style={{ height: `${isPhone ? "" : "100vh"}` }}
      >
        <h2
          className="main-heading"
          style={{ color: `${lightTheme ? "#393E46" : "#FCFFE7"}` }}
        >
          {currentProject?.title.slice(0, currentProject.sliceIndex)}
          <span>
            {currentProject?.title.slice(
              currentProject.sliceIndex,
              currentProject.sliceIndex + 1
            )}
          </span>
          {currentProject?.title.slice(currentProject.sliceIndex + 1)}
        </h2>
        <div
          className={`project-details ${
            isPhone ? (lightTheme ? "light-shadow" : "dark-shadow") : null
          }`}
          style={{
            backgroundColor: `${isPhone ? (lightTheme ? "#fff" : "#000") : ""}`,
          }}
        >
          <a href={currentProject?.link} target="_blank">
            {currentProject?.link == "" ? "Not Available" : "View Project"}
          </a>
          <img
            className="project-img"
            src={`${urlRoot}${currentProject?.img}`}
            alt="project-image"
          />
          <p className={`desc ${lightTheme ? "light" : "dark"}`}>
            {currentProject?.desc}
          </p>
        </div>
      </div>
    </section>
  );
}

export default Project
